import * as React from 'react';

import './ErrorMsg.scss';

interface ErrorMsgProps {
  errors: string[];
}

const ErrorMsg = ({ errors }: ErrorMsgProps) => <div className="error">{errors[0]}</div>;

export default ErrorMsg;
